module.exports = __webpack_public_path__ + "img/eg-hk-04.5125cf64.png";